<template>
  <div>
    <v-layout wrap justify-center mt-12 v-if="user.data && user.data.isEmailVerified">
      <v-flex xs6 text-center>
        <h1>{{ $t('b') }}</h1>
        <v-layout wrap mt-6 mb-2 justify-center>
          <v-flex xs12 text-center>
            <img :src="images.top" height="250px" class="mb-4"/>
          </v-flex>
        </v-layout>
        <div class="mt-6">
          <v-btn to="/onboarding/personal-data" class="secondary white--text">{{ $t('d') }}</v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-layout wrap v-else mt-12 pt-12 justify-center>
      <v-flex xs4>
        <v-progress-linear indeterminate color="primary" class="mt-3"></v-progress-linear>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    images: {
      top: require('@/assets/app/images/online_protection_flatline.svg'),
    },
  }),
  mounted() {
    this.regularlyUpdateUserIsEmailVerified()
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
  },
  methods: {
    async regularlyUpdateUserIsEmailVerified() {
      await this.$functions.httpsCallable('updateUserIsEmailVerified')({})
      const _this = this
      setTimeout(function() {
        _this.regularlyUpdateUserIsEmailVerified()
      }, 8000)
    }
  }
}
</script>


<i18n>
{
  "fr": {
    "b": "Votre adresse email est vérifée",
    "d": "Suivant"
  },
  "en": {
    "b": "Your email address is verified",
    "d": "Next"
  }
}
</i18n>